export default __webpack_public_path__ + "static/media/home-active.9f785300.svg";